/** @jsx jsx */

import { Fragment as _, memo } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext } from './interactionContext';
import HotSpot from './HotSpot';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Block } from '@chameleoncreator/creator-app';
import EditableBtn from 'components/lib/EditableBtn';
import IELayout from 'components/Layouts/IELayout';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import Media from 'components/lib/Media';
import shouldUpdate from 'services/shouldUpdate';
import hatLaptopGuy from 'assets/animations/hatLaptopGuy.js';
import placeholder from 'assets/addImg@3x.svg';
import HotSpotScorable from './HotSpotScorable';
import Feedback from 'components/lib/Feedback/Feedback_updated_022022';
// Feedback_updated_2022

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: EditableBtn,
  Image: ({ children, ...props }) => {
    //
    if (!props.src) {
      return (
        <SVG
          {...{
            ...props,
            src: JSON.stringify(hatLaptopGuy),
          }}
        />
      );
    }

    return (
      <Image
        {...{
          ...props,
          usePlaceholderValue: true,
          maxHeight: 30,
        }}
      />
    );
  },
  Video,
  SVG,
  Media,
  HotSpotElement: ({ children, ...props }) => children,
  HotSpotIsolated: HotSpot,
  HotSpotScorable,
  Answer: () => null,
  Feedback,
  Correct: ({ children, ...props }) => children,
  Incorrect: ({ children, ...props }) => children,
  Attempt: ({ children, ...props }) => children,
  Modal: () => null,
  ModalWithEditableBtn: () => null,
  ...IELayout(interactionContext),
};

const HotSpotDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{
          ...interactionBlock,
          isOpen: props.isOpen,
          updateItemsSeen: null,
        }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default HotSpotDisplay;
